

































import {
  defineComponent,
  onMounted,
  computed,
  ref,
  onBeforeUnmount,
  onBeforeMount
} from "@vue/composition-api";
import NavBar from "@/components/NavBar.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import Help from "@/components/Help.vue";
import NotificationOverlay from "@/components/NotificationOverlay.vue";
import Modals from "@/components/Modals.vue";
import { useVuex } from "@/hooks/use-vuex";
import { useMeta, useRouter } from "@/hooks/use-router";
import { handleError } from "@/lib/error-handling";
import { notify } from "@/store";
import { Notification } from "@/models/notification";
import { NotifyResult } from "@/store/Notifications";
import { usePrices } from "@/hooks/use-prices";

export default defineComponent({
  components: {
    NavBar,
    LoadingOverlay,
    Help,
    NotificationOverlay,
    Modals
  },
  setup(_, ctx) {
    const {
      store: { state, getters, commit, dispatch }
    } = useVuex();
    const router = useRouter();
    const loading = computed(() => state.Loading.loading);
    const help = computed(() => state.Help);
    const activeHelpStep = computed(() => getters.Help.activeHelpStep);
    const meta = useMeta(ctx);
    const notification = ref<Notification | null>(null);
    const { initBasePrices, updatePrices } = usePrices();
    let appTimer: any;

    const timer = async () => {
      const oldVal = state.Loading.online;
      const { onLine } = navigator;

      if (oldVal !== onLine) {
        notification.value?.dismiss();
        commit.Loading.setOnline(onLine);
        const result = !onLine
          ? await handleError(
              { onLine },
              "You're offline. Make sure you're connected to the internet and try again.",
              2500,
              true
            )
          : await notify({
              text: "You're back online",
              type: "success",
              duration: 2500,
              payload: { onLine }
            });
        if (onLine) router.back();
        notification.value = (await result).notification;
      }
    };

    onBeforeMount(async () => {
      await initBasePrices();
      dispatch.Wallet.updateWallets(false);
      appTimer = setInterval(timer, 1000);
      timer();
      dispatch.Notifications.dismissAll();
      dispatch.Settings.initTheme();
      updatePrices().then(() => dispatch.Wallet.updateWallets(false));
      if (state.Console.logging) dispatch.Console.enableLogging();
    });

    onBeforeUnmount(() => clearInterval(appTimer));

    return {
      loading,
      help,
      activeHelpStep,
      meta
    };
  }
});
